module.exports = "<div id=\"coordContainer\">\n  <p id=\"scaleLine\">\n    Level: <i id=\"zoom\">{{mapView.zoom  | number:'.0-0'}}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Scale: <i id=\"scale\">{{mapView.scale | number:'.0-0'}}</i>\n  </p>\n  <p id=\"coordinatesLine\">\n    Lat: <i id=\"longitude\">{{longitude | number:'.6-6'}}</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Lon: <i id=\"latitude\">{{latitude | number:'.6-6'}}</i>\n  </p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/coordinate/coordinate.component.html
// module id = 663
// module chunks = 1